export const Footer = () => (
  <footer className="zone-resolution py-6 border-t border-border">
    <div className="container-wide">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded bg-primary flex items-center justify-center">
            <span className="text-primary-foreground font-heading font-bold text-xs">C</span>
          </div>
          <span className="font-heading font-semibold text-foreground text-sm">Clarity</span>
        </div>
        <p className="text-xs text-muted-foreground">Make products easier to understand.</p>
        <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Clarity</p>
      </div>
    </div>
  </footer>
);

export default Footer;
